// extracted by mini-css-extract-plugin
export default {"single-risk-center__header":"Header_single-risk-center__header__eRCxQ","single-risk-center__header-actions":"Header_single-risk-center__header-actions__7AC8o"};